export const SET_PRELOADER = 'SET_PRELOADER';
